<ion-header>
  <ion-toolbar mode="md" color="light">
    <ion-buttons slot="start">
      @if (back && !hideBackBtn) {
        <a class="back-button" [routerLink]="back.path" [queryParams]="queryParams" (click)="cancel()">
          <mat-icon>arrow_back</mat-icon>
          @if (back.text && back.text !== 'back') { &nbsp;{{ back.text }} } @else { <span class="sr-only">Back</span>}
        </a>
      }
    </ion-buttons>
    <ion-title>
      <a [routerLink]="['/rides/future']" class="logo-link">
        <img [alt]="appName" class="header-logo" src="assets/img/logo.svg" />
      </a>
    </ion-title>
  </ion-toolbar>
</ion-header>
